import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/trader/Layout';
import Home from './pages/trader/Home';
import Login from './pages/trader/Login';
import Signup from './pages/trader/Signup';
import Dashboard from './pages/trader/Dashboard';
import WhatsAppLayout from './components/whatsappapi/Layout';
import WhatsappAppLayout from './components/whatsappapi/AppLayout';

import WhatsAppHome from './pages/whatsappapi/Home';
import WhatsappDashboard from './pages/whatsappapi/WhatsappDashboard';
import Message from './pages/whatsappapi/Message';
import ReceivedMessage from './pages/whatsappapi/ReceivedMessage';

import Payment from './pages/whatsappapi/Payment';


import WhatsappapiLogin from './pages/whatsappapi/Login';
import WhatsappapiOrderStatus from './pages/whatsappapi/OrderStatus';
import WhatsappapiDashboardNoAuth from './pages/whatsappapi/WhatsappDashboardNoAuth';
import WhatsappapiSignup from './pages/whatsappapi/Signup';

import KitstersLayout from './components/kitsters/Layout';
import KitstersAppLayout from './components/kitsters/AppLayout';

import KitstersLogin from './pages/kitsters/Login';
import KitstersDashboard from './pages/kitsters/Dashboard';
import KitstersSetting from './pages/kitsters/Setting';
import BillAttachmentCheck from './pages/kitsters/BillAttachmentCheck';
import ExpenseAttachmentCheck from './pages/kitsters/ExpenseAttachmentCheck';
import ItemStockCheck from './pages/kitsters/ItemStockCheck';
import ItemNegativeStockCheck from './pages/kitsters/ItemNegativeStockCheck';
import ItemNameCheck from './pages/kitsters/ItemNameCheck';
import BundleCheck from './pages/kitsters/BundleCheck';
import VendorAttachmentCheck from './pages/kitsters/VendorAttachmentCheck';
import AmazonOrderCheck from './pages/kitsters/AmazonOrderCheck';


import AppointmentLayout from './components/appointment/Layout';
import AppointmentAppLayout  from './components/appointment/AppLayout';

import AppointmentHome from './pages/appointment/Home';
import Appointment from './pages/appointment/Appointment';

import AppointmentLogin from './pages/appointment/Login';
import AppointmentSignup from './pages/appointment/Signup';
import ProtectedRoute from './components/ProtectedRoute'; 

import AppointmentDummyPayment from './pages/appointment/DummyPayment';
import AppointmentPaymentUpdate from './pages/appointment/PaymentUpdate';
import PrescriptionAdmin from './pages/appointment/PrescriptionAdmin';
import AppointmentAdmin from './pages/appointment/AppointmentAdmin';
import PatientnAdmin from './pages/appointment/PatientAdmin';
import Prescription from './pages/appointment/Prescription';
import NoAuthPrescriptionView from './pages/appointment/NoAuthPrescriptionView';
import AppointmentSetting from './pages/appointment/Setting';
import IntakeForm from './pages/appointment/IntakeForm';
import IntakeFormView from './pages/appointment/IntakeFormView';

import ChiefLayout    from './components/chiefofstaff/Layout';
import ChiefAppLayout from './components/chiefofstaff/AppLayout';
import ChiefHome      from './pages/chiefofstaff/Home';
import ChiefLogin     from './pages/chiefofstaff/Login';
import ChiefSignup    from './pages/chiefofstaff/Signup';
import ChiefDashboard from './pages/chiefofstaff/Dashboard';
import ChiefSettings  from './pages/chiefofstaff/Settings';
import ZohoSetting  from './pages/chiefofstaff/ZohoSetting';
import BillAttachmentCheck from './pages/kitsters/BillAttachmentCheck';
import ItemVendorCheck from './pages/kitsters/ItemVendorCheck';
import BundleCheck from './pages/kitsters/BundleCheck';

import PrudentialLayout    from './components/prudential/Layout';
import PrudentialAppLayout from './components/prudential/AppLayout';
import PrudentialLogin     from './pages/prudential/Login';
import PrudentialDashboard from './pages/prudential/Dashboard';
import PrudentialLedgers   from './pages/prudential/Ledgers';
import PrudentialReview    from './pages/prudential/Review';

const params = new URLSearchParams(window.location.search);
export let APPSETTING = localStorage.getItem('appsetting') ? JSON.parse(localStorage.getItem('appsetting') || "{}"): null;
//console.log("APPSETTING > ", APPSETTING);
if (!APPSETTING?.appname && !params.get("appname") && document.location.href.match(/senddit.in|ssl.itpatil.com/gi) ) {
  APPSETTING = {adminuserid:"6a043a73ef964e67e1c77ec0", appname:"whatsappapi"};
  localStorage.setItem("appsetting", JSON.stringify(APPSETTING));
} else if (params.get("appname")) {
  APPSETTING = {adminuserid:params.get("adminuserid"), appname:params.get("appname")};
  localStorage.setItem("appsetting", JSON.stringify(APPSETTING));
}
console.log(APPSETTING);
window.APPSETTING = APPSETTING;


const link = document.createElement('link');
link.rel = 'stylesheet';
let csshref = `/css/trader/style.css`;
document.head.appendChild(link);
let title = "Trader";
if (APPSETTING.appname == "kitsters") {
  csshref = csshref.replace("trader", "kitsters");
  title = "Kitsters Data App";
} else if (APPSETTING.appname == "whatsappapi") {
  csshref = csshref.replace("trader", "whatsappapi");
  title = "WhatsappApi";
} else if (APPSETTING.appname == "appointment") {
  csshref = csshref.replace("trader", "appointment");
  title = "Appointmet - devbranch V4";
} else if (APPSETTING.appname == "chiefofstaff") {
  csshref = csshref.replace("trader", "chiefofstaff");
  title = "AI Chief of Staff";
} else if (APPSETTING.appname == "prudential") {
  csshref = csshref.replace("trader", "prudential");
  title = "Prudential · Expense Review";
}
link.href = csshref;
$(".pagetitle").html(title);

export const APPUSER = JSON.parse(localStorage.getItem(APPSETTING.appname + "user") || "{}");
window.APPUSER = APPUSER;

if (window.APPSETTING?.appname === "kitsters") {
  window.location.href = "https://tools-kitsters.vercel.app/login";
}

ReactDOM.createRoot(document.getElementById('root')!).render(
    <BrowserRouter>
      <Routes>
        {/* Trader App Routing */}
        {window.APPSETTING.appname === "trader" && (
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/dashboard" element={<Dashboard />} />
          </Route>
        )}
        
        {/* WhatsApp API App Routing */}
        {window.APPSETTING.appname === "whatsappapi" && (
          <Route path="/" element={<WhatsAppLayout />}>
            <Route index element={<WhatsAppHome />} />
            <Route path="/login" element={<WhatsappapiLogin />} />
            <Route path="/signup" element={<WhatsappapiSignup />} />
            <Route path="/orderstatus" element={<WhatsappapiOrderStatus />} />
            <Route path="/dashboardnoauth" element={<WhatsappapiDashboardNoAuth />} />

            <Route element={<ProtectedRoute />}>
              <Route path="/dashboard" element={<WhatsappAppLayout />}>
                <Route index element={<WhatsappDashboard />} />
              </Route>
              <Route path="/message" element={<WhatsappAppLayout />}>
                <Route index element={<Message />} />
              </Route>
              <Route path="/receivemessage" element={<WhatsappAppLayout />}>
                <Route index element={<ReceivedMessage />} />
              </Route>
              <Route path="/payment" element={<WhatsappAppLayout />}>
                <Route index element={<Payment />} />
              </Route>
            </Route>
          </Route>
        )}

        {/* Kitsters Routing */}
        {window.APPSETTING.appname === "kitsters" && (
          <Route path="/" element={<KitstersLayout />}>
            <Route path="/login" element={<KitstersLogin />} />
            <Route path="/bill-report" element={<BillAttachmentCheck />} />
            <Route path="/expense-report" element={<ExpenseAttachmentCheck />} />
            <Route path="/item-stock-report" element={<ItemStockCheck />} />
            <Route path="/item-negative-report" element={<ItemNegativeStockCheck />} />
            <Route path="/item-name-report" element={<ItemNameCheck />} />
            <Route path="/item-vendor-report" element={<ItemVendorCheck />} />
            <Route path="/bundle-report" element={<BundleCheck />} />
            <Route path="/vendor-attachment-report" element={<VendorAttachmentCheck />} />

            <Route element={<ProtectedRoute />}>
              <Route path="/dashboard" element={<KitstersAppLayout />}>
                <Route index element={<KitstersDashboard />} />
              </Route>
              <Route path="/billattachmentcheck" element={<KitstersAppLayout />}>
                <Route index element={<BillAttachmentCheck />} />
              </Route>
              <Route path="/vendorattachmentcheck" element={<KitstersAppLayout />}>
                <Route index element={<VendorAttachmentCheck />} />
              </Route>
              <Route path="/expenseattachmentcheck" element={<KitstersAppLayout />}>
                <Route index element={<ExpenseAttachmentCheck />} />
              </Route>
              <Route path="/itemstockcheck" element={<KitstersAppLayout />}>
                <Route index element={<ItemStockCheck />} />
              </Route>
              <Route path="/itemnegativestockcheck" element={<KitstersAppLayout />}>
                <Route index element={<ItemNegativeStockCheck />} />
              </Route>
              <Route path="/itemnamecheck" element={<KitstersAppLayout />}>
                <Route index element={<ItemNameCheck />} />
              </Route>
              <Route path="/itemvendorcheck" element={<KitstersAppLayout />}>
                <Route index element={<ItemVendorCheck />} />
              </Route>
              <Route path="/bundlecheck" element={<KitstersAppLayout />}>
                <Route index element={<BundleCheck />} />
              </Route>
              <Route path="/amazonordercheck" element={<KitstersAppLayout />}>
                <Route index element={<AmazonOrderCheck />} />
              </Route>
              <Route path="/setting" element={<KitstersAppLayout />}>
                <Route index element={<KitstersSetting />} />
              </Route>
            </Route>
          </Route>
        )}


        {/* Appointment App Routing */}
        {window.APPSETTING.appname === "appointment" && (
          <>
            {/* Public Routes with standard Layout */}
            <Route path="/" element={<AppointmentLayout />}>
              <Route index element={<AppointmentHome />} />
              <Route path="/login" element={<AppointmentLogin />} />
              <Route path="/signup" element={<AppointmentSignup />} />
              <Route path="/prescriptionview" element={<NoAuthPrescriptionView />} />
              <Route path="/intakeform" element={<IntakeForm />} />

            </Route>

            <Route element={<ProtectedRoute />}>
              <Route path="/dashboard" element={<AppointmentAppLayout />}>
                <Route index element={<PatientnAdmin />} />
              </Route>
              <Route path="/prescriptionadmin" element={<AppointmentAppLayout />}>
                <Route index element={<PrescriptionAdmin />} />
              </Route>
              <Route path="/appointmentadmin" element={<AppointmentAppLayout />}>
                <Route index element={<AppointmentAdmin />} />
              </Route>
              <Route path="/prescription" element={<AppointmentAppLayout />}>
                <Route index element={<Prescription />} />
              </Route>
              <Route path="/patientadmin" element={<AppointmentAppLayout />}>
                <Route index element={<PatientnAdmin />} />
              </Route>
              <Route path="/setting" element={<AppointmentAppLayout />}>
                <Route index element={<AppointmentSetting />} />
              </Route>
              <Route path="/intakeformview" element={<AppointmentAppLayout />}>
                <Route index element={<IntakeFormView />} />
              </Route>
              <Route path="dummypayment" element={<AppointmentDummyPayment />} />
              <Route path="paymentupdate" element={<AppointmentPaymentUpdate />} />
            </Route>
          </>
        )}
        {/* Chief of Staff Routing */}
        {window.APPSETTING.appname === "chiefofstaff" && (
          <Route path="/" element={<ChiefLayout />}>
            <Route index element={<ChiefHome />} />
            <Route path="/login"  element={<ChiefLogin />} />
            <Route path="/signup" element={<ChiefSignup />} />

            <Route element={<ProtectedRoute />}>
              <Route path="/dashboard" element={<ChiefAppLayout />}>
                <Route index element={<ChiefDashboard />} />
              </Route>
              <Route path="/settings" element={<ChiefAppLayout />}>
                <Route index element={<ChiefSettings />} />
              </Route>
              <Route path="/zohosetting" element={<ChiefAppLayout />}>
                <Route index element={<ZohoSetting />} />
              </Route>
            </Route>
          </Route>
        )}
        {/* Prudential Routing */}
        {window.APPSETTING.appname === "prudential" && (
          <Route path="/" element={<PrudentialLayout />}>
            <Route path="/login" element={<PrudentialLogin />} />

            <Route element={<ProtectedRoute />}>
              <Route path="/dashboard" element={<PrudentialAppLayout />}>
                <Route index element={<PrudentialDashboard />} />
              </Route>
              <Route path="/ledgers" element={<PrudentialAppLayout />}>
                <Route index element={<PrudentialLedgers />} />
              </Route>
              <Route path="/review" element={<PrudentialAppLayout />}>
                <Route index element={<PrudentialReview />} />
              </Route>
            </Route>
          </Route>
        )}

      </Routes>
    </BrowserRouter>
)

// TypeScript Declaration (add to a d.ts file or top of file)
declare global {
  interface Window { APPSETTING: any; APPUSER:any;}
}
